/* eslint-disable react/button-has-type */
// import zeeve from '../../images/zeeveLogo';

interface Props {
  step: number;
  nextStep?: () => void;
  prevStep?: () => void;
  submit?: () => void;
  disable: boolean;
}
function Footer({
  step, nextStep, prevStep, submit, disable,
}: Props) {
  return (
    <div className="col-11 my-5 mx-auto">
      <div className="row d-flex mx-auto">
        <div className="col-xl-8 col-lg-8 col-md-2 mb-4 justify-content-center">
        {/* <img src={zeeve} alt="ethereum-logo" width="141px" height="34px" /> */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-10 d-flex justify-content-end">
          <div>
           {step > 1 ? (
            <button
              type="button"
              className="btn btn-outline-secondary mx-3 px-5"
              onClick={prevStep}
            >
              Back
            </button>
           ) : null}
            {step === 1 ? (
              <button
                type="button"
                className="btn btn-success px-4"
                onClick={nextStep}
                disabled={disable}
              >
                Next
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-success px-4"
                onClick={submit}
                disabled={disable}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>

  );
}

export default Footer;
